import { Auth } from "@aws-amplify/auth";
import { Hub } from "@aws-amplify/core";

import { PCLogger } from "../server/ServerContext";

/**
 * Cognito errors that do now have an exported constant from amplify-js.
 */
export const CognitoError = {
  // The error code thrown when there is a network connection error.
  NetworkConnection: "NetworkConnection",
  // https://github.com/aws-amplify/amplify-js/blob/main/packages/auth/src/Auth.ts#L1278
  NoCurrentUser: "No current user",
  // The error code thrown when a user becomes unauthorized (revoked, expired, etc..)
  NotAuthorizedException: "NotAuthorizedException",
  // The error message thrown when a user's refresh token expires.
  RefreshTokenExpired: "Refresh Token has expired",
  // https://github.com/aws-amplify/amplify-js/blob/main/packages/auth/src/Auth.ts#L1411
  UserNotAuthenticated: "The user is not authenticated",
};

export const getSession = async (source: string = "portal-client") => {
  try {
    const session = await Auth.currentSession();
    return session;
  } catch (error) {
    if (error !== CognitoError.NoCurrentUser) {
      PCLogger?.warn(
        `[getSession][source=${source}] failed to retrieve Cognito session: ${JSON.stringify(
          error
        )}`
      );
    }
    throw error;
  }
};

export const getAccessToken = async (source: string = "portal-client") => {
  try {
    const session = await getSession(source);
    return session.getAccessToken().getJwtToken();
  } catch (error) {
    if (error !== CognitoError.NoCurrentUser) {
      PCLogger?.warn(
        `[getAccessToken][source=${source}] failed to retrieve Cognito access token: ${JSON.stringify(
          error
        )}`
      );
    }
    throw error;
  }
};

export const getExpiration = async () => {
  const session = await Auth.currentSession();
  return session.getAccessToken().getExpiration();
};

export const isUnauthenticated = (error: any) => {
  return (
    error === CognitoError.NoCurrentUser ||
    error === CognitoError.UserNotAuthenticated
  );
};

export { Hub };

export default Auth;
